import { helpers } from "../../common/lib";
import getInitialState from "../get-initial-state";
import { actionTypes } from "./actions";

export default function(state = getInitialState.list(), action) {
  switch (action.type) {
    case actionTypes.AUDIT_ARCHIVE_GET_SUCCESS:
    case actionTypes.AUDIT_ARCHIVE_SET: {
      const { auditArchive } = action.payload;
      return helpers.getListReducer(state, auditArchive);
    }
    case actionTypes.AUDIT_ARCHIVE_MERGE: {
      const { auditArchive } = action.payload;
      return helpers.mergeListReducer(state, auditArchive);
    }
    case actionTypes.AUDIT_ARCHIVE_CLEAR:
    case actionTypes.AUDIT_ARCHIVE_GET_REQUEST: {
      return getInitialState.list();
    }

    case actionTypes.AUDIT_ARCHIVE_ITEM_SET: {
      const { auditArchive } = action.payload;
      return { ...state, item: auditArchive };
    }
    case actionTypes.AUDIT_ARCHIVE_POST_REQUEST: {
      const { auditArchive } = action.payload;
      return { ...state, item: auditArchive };
    }

    default: {
      return state;
    }
  }
}
